import React, { memo, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import MaterialSlider from '@mui/material/Slider';
import { Colors } from 'modules/theme';
import { secondsToDuration } from '../../../audio/services/assets';
import classesFromFile from './Slider.module.scss';

const Root = styled('div')(({ sliderStyle }) => ({
  color: Colors.grayishBlue,
  paddingTop: 11,
  paddingBottom: 11,
  ...sliderStyle,
}));

const StyledSlider = styled(MaterialSlider)(({ darkMode }) => ({
  '& .MuiSlider-rail': {
    backgroundColor: darkMode ? '#e4ecf4' : '#929aad',
    opacity: 1,
  },
  '& .MuiSlider-track': {
    border: 'none',
    backgroundColor: darkMode ? '#53a2ff' : '#3E5EA8',
  },
  '& .MuiSlider-thumb': {
    backgroundColor: darkMode ? '#53a2ff' : '#3E5EA8',
  },
}));

function Slider({
  min = 0,
  max,
  value,
  setValue,
  sliderStyle,
  containerClassName,
  durationLabelClassName,
  darkMode,
}) {
  const containerClasses = classNames(
    classesFromFile.container,
    containerClassName,
  );

  const durationLabelClasses = classNames(
    classesFromFile.durationLabel,
    durationLabelClassName,
  );

  const [sliderValue, setSliderValue] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);

  useEffect(() => {
    if (!isSeeking) {
      setSliderValue(value);
    }
  }, [isSeeking, value]);

  function handleChange(_, newValue) {
    setIsSeeking(true);
    setSliderValue(newValue);
  }

  function handleChangeCommitted(_, newValue) {
    setIsSeeking(false);
    setValue(newValue);
  }

  return (
    <Root className={containerClasses} sliderStyle={sliderStyle}>
      <div className={durationLabelClasses}>{secondsToDuration(value)}</div>
      <StyledSlider
        min={min}
        max={max}
        value={sliderValue}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        aria-labelledby="continuous-slider"
        component="div"
        darkMode={darkMode}
      />
      <div className={durationLabelClasses}>{secondsToDuration(max)}</div>
    </Root>
  );
}

export default memo(Slider);
